const Helper = (function(){
  function isEmpty(obj){
    // null and undefined are "empty"
    if (obj == null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0)    return false;
    if (obj.length === 0)  return true;

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== "object") return true;

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (let key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
  };
  
  function isValidUrl(url) {
    try {
      new URL(url);
      
      return true;
    } catch {
      return false;
    }
  };
  
  function getDecodedValue(base64String) {
    if (!base64String) return null;

    try {
      return Buffer.from(base64String, 'base64').toString('utf8');
    } catch (err) {
      return null;
    }
};

  return {
    isEmpty: isEmpty,
    isValidUrl: isValidUrl,
    getDecodedValue: getDecodedValue
  }
})();

export default Helper;
